import React from 'react';
import "./Contact.css";

const Map = () => {
  return (
    <div className='map-content'>
        {/* eslint-disable-next-line */}
    <iframe
  // src="https://www.google.com/maps?q=Subidhanagar,Kathmandu&output=embed"
  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3533.060204153562!2d85.34178547546657!3d27.684534076195682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjfCsDQxJzA0LjMiTiA4NcKwMjAnMzkuNyJF!5e0!3m2!1sen!2snp!4v1782664364812!5m2!1sen!2snp"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>  </div>
  )
}

export default Map


